export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/getup_mobile-a0c32652b1e2191e6faf01447baae8fe.png";